import { atomWithStorage, createJSONStorage } from "jotai/utils";
import type { RentalBookingKeyPayload } from "@/components/main-services/rentals/checkout/rental.checkout.type";
import type { AppliedCouponSessionPayload } from "@/types/coupon";
import { CheckoutPayload } from "@/hooks/booking-checkout/booking.checkout.helpers";

const noopStorage = {
  getItem: () => null,
  setItem: () => { },
  removeItem: () => { },
};

const rentalCheckoutStorage = createJSONStorage<CheckoutPayload | null>(
  () => (typeof window === "undefined" ? noopStorage : window.sessionStorage),
);

export const rentalCheckoutPayloadAtom =
  atomWithStorage<CheckoutPayload | null>(
    "tovtrip_rental_checkout_payload",
    null,
    rentalCheckoutStorage,
    { getOnInit: true },
  );

const rentalBookingKeyStorage =
  createJSONStorage<RentalBookingKeyPayload | null>(() =>
    typeof window === "undefined" ? noopStorage : window.sessionStorage,
  );
const rentalAppliedCouponStorage =
  createJSONStorage<AppliedCouponSessionPayload | null>(() =>
    typeof window === "undefined" ? noopStorage : window.sessionStorage,
  );

export const rentalBookingKeyAtom =
  atomWithStorage<RentalBookingKeyPayload | null>(
    "tovtrip_rental_booking_key",
    null,
    rentalBookingKeyStorage,
    { getOnInit: true },
  );

export const rentalAppliedCouponAtom =
  atomWithStorage<AppliedCouponSessionPayload | null>(
    "tovtrip_rental_applied_coupon",
    null,
    rentalAppliedCouponStorage,
    { getOnInit: true },
  );

export const rentalVehicleSelectionAtom =
  atomWithStorage<any | null>(
    "tovtrip_rental_vehicle_selection",
    null,
    rentalCheckoutStorage,
    { getOnInit: true },
  );